import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class BanKThaiReportProvider {

  private _service: string = 'payroll';
  private _model: string = 'bankthaireport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public downloadFormatBank(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadFormatBank';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public downBankReportTH(filter: any): Observable<any> {
    const _method: string = 'GET';

    const _func: string = 'downBankReport';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/bank-thai-report/bank-thai-report.ts